import Full from 'Container/Full'

const RicercaAbbonati = () => import('Views/abbonati/Search');
const Abbonato = () => import('Views/abbonati/Abbonato');
const NewUser = () => import('Views/users/NewUser');
const ListUsers = () => import('Views/users/ListUsers');
const EditUser = () => import('Views/users/EditUser');
const ChangePassword = () => import('Views/users/ChangePassword');

export default {
    path: '/',
    component: Full,
    redirect: '/login',
    children: [
        {
            path: '/abbonati/ricerca',
            component: RicercaAbbonati,
            meta: {
                requiresAuth: true,
                title: 'Ricerca Nominativo',
                breadcrumb: 'Controllo Abbonati / Ricerca Nominativo'
            }
        },
        {
            path: '/abbonato/:id',
            component: Abbonato,
            name: 'abbonato',
            meta: {
                requiresAuth: true,
                title: 'Abbonato',
                breadcrumb: 'Controllo Abbonati / Scheda Abbonato'
            }
        },
        {
            path: '/users/new-user',
            component: NewUser,
            meta: {
                requiresAuth: true,
                title: 'Creazione nuovo utente',
                breadcrumb: 'Utenti / Creazione Nuovo Utente'
            }
        },
        {
            path: '/users/change-password',
            component: ChangePassword,
            meta: {
                requiresAuth: true,
                title: 'Cambio password',
                breadcrumb: 'Utenti / Cambio password'
            }
        },
        {
            path: '/users/:id',
            component: EditUser,
            meta: {
                requiresAuth: true,
                title: 'Modifica utente',
                breadcrumb: 'Utenti / Modifica Utente'
            }
        },
        {
            path: '/users',
            component: ListUsers,
            meta: {
                requiresAuth: true,
                title: 'Lista utenti',
                breadcrumb: 'Utenti / Lista Utenti'
            }
        }
    ]
}
